'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('momentDate', ['languageSvc', function (languageSvc) {
    return function (date, format, callback) {
      var m = moment(date);
      if (!m || !m.isValid()) {
        return '';
      }
      m.locale(languageSvc.getLanguage());
      if (_.isFunction(callback)) {
        callback(m, languageSvc.getLanguage());
      }
      return m.format(format);
    };
  }]);
})();